import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  throw new Error('VITE_SUPABASE_URL veya VITE_SUPABASE_ANON_KEY eksik (.env.local)');
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Tip alias'lar — supabase gen types yerine elle (db küçük)
export interface AdminUser {
  id: string;
  email: string;
  display_name: string | null;
  is_master: boolean;
  is_active: boolean;
  created_at: string;
  created_by: string | null;
  notes: string | null;
}

export interface VoiceProfile {
  id: string;
  slug: string;
  display_name: string;
  elevenlabs_voice_id: string;
  model_id: string;
  stability: number;
  similarity_boost: number;
  style: number;
  use_speaker_boost: boolean;
  description: string | null;
  sample_audio_url: string | null;
  category: string | null;
  is_active: boolean;
  display_order: number;
}

export interface AudioHistoryRow {
  id: string;
  created_at: string;
  actor_email: string;
  voice_slug: string | null;
  text_full: string;
  text_chars: number;
  storage_path: string;
  public_url: string;
  bytes: number | null;
  elevenlabs_voice_id: string;
  estimated_cost_usd: number | null;
  meta: Record<string, unknown>;
}

// Ses erişimi modalinde kullanılan kısmi voice_profiles satırı
export interface VoiceRow {
  id: string;
  slug: string;
  display_name: string;
  category: string | null;
}

export interface UserVoiceAccess {
  admin_user_id: string;
  voice_profile_id: string;
  granted_by: string;
  granted_at: string;
}

export interface AuditLogRow {
  id: string;
  created_at: string;
  actor_email: string;
  action: string;
  target_type: string | null;
  target_id: string | null;
  target_label: string | null;
  metadata: Record<string, unknown>;
}
